{
  "01a48705b40e69f7": "Filtrar por nombre o ID de documento",
  "03867aea70acaf4c": "Evidencia",
  "069d7e9d898e4d81": "ID del trabajador",
  "0b1548eb25a9799d": "Error al cargar la vista previa del documento.",
  "0cd55c8e8865f98b": "Definición desconocida",
  "19fbc2613e4a1d81": "Cargando vista previa del documento...",
  "1a83135d903dcd9e": "Definición de evidencia",
  "1ea442a134b2a184": "No",
  "2677214a9268a547": "En revisión",
  "271d48fc7d5d9dd4": "Evidencia actualizada con éxito",
  "29c37ce298a5399a": "Error al cargar las definiciones de evidencia. Las propiedades de la evidencia no se pueden editar.",
  "2aa9e2ac7a12cb55": "Seleccionar una definición",
  "2cd3f75e8d4737b4": "Definición de evidencia no encontrada. Las propiedades de la evidencia no se pueden editar.",
  "2ed9337dcc8cf799": "Ver evidencia",
  "2f2a95ec93b25e34": "ID del Documento",
  "2f491f07735e7056": "Nombre de la Definición",
  "331551b0de4157c9": "Pendiente",
  "356358348d9a0262": "Comienza a escribir para buscar definiciones de evidencia",
  "3d03011c07c575f8": "Secciones de evidencia del trabajador",
  "3d44337010bfbdf7": "Creado El",
  "4976197fe3f2bdd4": "Por favor, ingrese un ID de Trabajador válido para ver documentos y evidencias.",
  "5265434bb9e0e789": "Error al cargar los documentos. Por favor, inténtelo de nuevo.",
  "6cbf9de5aca6b84c": "No hay documentos que coincidan con el filtro.",
  "6e9a4c33b916d1a4": "No se encontraron definiciones de evidencia",
  "6ee7448a9c057091": "Evidencias",
  "6f5708dda91a3dd7": "Seleccionar {{fieldKey}}",
  "6fed375409557a57": "Error al cargar las evidencias. Por favor, inténtelo de nuevo.",
  "76f14c379dff48a2": "No se encontraron documentos para este trabajador.",
  "799ccd9dee898c80": "Documentos existentes",
  "85a39ab345d672ff": "Sí",
  "87b42e40c2a290e0": "Aprobado",
  "8c13bf02a1a2b30e": "Evidencias del Trabajador",
  "920e413c7d411b61": "Estado",
  "94d5a7703a8250de": "Filtrar por estado",
  "9569cdd073575b1d": "No hay evidencias que coincidan con el filtro.",
  "a5cc6e9c339ea39b": "Filtrar por nombre de definición o ID de evidencia",
  "aea4a04a80426ed8": "Rechazado",
  "b4aaa11cf013f6d7": "Error al cargar las evidencias. La vinculación de evidencias puede estar incompleta.",
  "b5b8cb11a02602cf": "Ver documento",
  "b89ab3b119b92f94": "Editar evidencia",
  "bc601ec106f42318": "Evidencia creada con éxito",
  "d1957085c29dbd37": "ID de Evidencia",
  "d600e62a6861fced": "Fecha de Expiración",
  "d8500d3836a2086e": "Seleccionar una definición de evidencia para continuar.",
  "dcd1d5223f73b3a9": "Nombre",
  "e198269c2a19003d": "Ocurrió un error inesperado. Por favor, inténtalo de nuevo.",
  "e35c8e4f5cb5c554": "Actualizado El",
  "e6db68ccd8cfaca3": "No se encontraron evidencias para este trabajador.",
  "e87247d44d94398d": "Esta definición no tiene propiedades para completar.",
  "ed71fe3a468e163d": "Buscando definiciones de evidencia...",
  "ed82cf60e617eb63": "Buscar por nombre...",
  "fea31386a31f34c6": "No se pudieron cargar las definiciones de evidencia. Por favor, inténtalo de nuevo.",
  "ff8059dc6752afdd": "Acciones"
}
